import React from "react";
import { FaCheck, FaInfoCircle } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import PropTypes from "prop-types";
import {
  JSXMainContainer,
  Header,
  PricingContainer,
  CurrencyContainer,
  PriceContainer,
  Price,
  SubTitle,
  PriceText,
  ButtonContainer,
  Button,
  DataContainer,
  FooterNote,
} from "./styled";

const Pricing = ({
  data,
  price,
  background,
  shadow = "#a0c5fa",
  buttonContent,
  currency = "PLN",
  subTitle,
  priceText,
  benefits,
  headerText,
}) => {
  return (
    <JSXMainContainer shadow={shadow}>
      <Header background={background}>{headerText}</Header>

      <PricingContainer>
        <PriceContainer>
          <CurrencyContainer>
            <span>{currency}</span>
          </CurrencyContainer>
          <Price>
            <span>{price}</span>
          </Price>
        </PriceContainer>

        {subTitle && (
          <SubTitle isPremium={headerText === "premium"}>
            <h4>{subTitle}</h4>
          </SubTitle>
        )}

        {priceText && <PriceText>{priceText}</PriceText>}
        {benefits && <PriceText>{benefits}</PriceText>}
      </PricingContainer>

      <ButtonContainer>
        {React.isValidElement(buttonContent) ? (
          buttonContent
        ) : (
          <Button to="/kontakt">{buttonContent}</Button>
        )}
      </ButtonContainer>

      {data && (
        <DataContainer>
          <ul>
            {data.map((dt, index) => (
              <li key={index}>
                {dt.value ? (
                  <FaCheck className="true" />
                ) : (
                  <ImCross className="false" />
                )}
                {dt.text}
              </li>
            ))}
            {headerText === "standard" && (
              <li>
                <ImCross className="false" /><span>Nielimitowany dostęp Premium </span>
                <FaInfoCircle className="info" style={{
        color: "inherit",
          fontSize: "0.7rem",
          lineHeight: "1",
          marginLeft: "0.25rem",
          marginRight: "0",
          position: "relative",
          top: "-0.3em"
  }}/>
              </li>
            )}
            {headerText === "standard" && (
              <li>
                <FaInfoCircle className="info" style={{
    marginRight: "0.6rem",
    fontSize: "0.7rem",
  }}/>
                <FooterNote to="/info" style={{
    fontSize: "0.7rem",
  }}> Dowiedz się więcej</FooterNote>
              </li>
            )}
          </ul>
        </DataContainer>
      )}
    </JSXMainContainer>
  );
};

Pricing.propTypes = {
  data: PropTypes.array.isRequired,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  buttonContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  currency: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  priceText: PropTypes.string,
  headerText: PropTypes.string.isRequired,
};

export default Pricing;